import { Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TfiMoreAlt } from "react-icons/tfi";

import styles from "../../styles/start-wizard/TopExchanges.module.css";
import { useLocation } from "react-router-dom";
import ExchangesModal from "../ExchangesModal";
import {
  getExchangesInfo,
  getIntegratedExchanges,
  openExchangeConnectionSettings,
} from "../../redux/exchange/actions";
import { certificatedExchange } from "../../utility/data";
import ExchangeRecommendationModal from "../exchanges/ExchangeRecommendationModal";
import UpdateExchangeIpModal from "../exchange-ip-setting/UpdateExchangeIpModal";
import * as React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

// const imgUrl =
//   "https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/binance.svg";

function TopExchanges() {
  const {
    exchangeState: {
      exchangesInfo,
      exchangesLoading,
      integratedData,
      integratedDataLoading,
      getIntegratedList,
      exchangesError,
      integratedDataError,
      topExchanges,
      confirmedExchanges,
    },
    main: { userData },
  } = useSelector((state) => state);
  const [selectedExchangeName, setSelectedExchangeName] = useState("");
  const [selectedExchangeId, setSelectedExchangeId] = useState("");
  const [showExchanges, setShowExchanges] = useState(false);
  const [showRecommendationModal, setShowRecommendationModal] = useState(false);
  const [showIpSettingsModal, setShowIpSettingsModal] = useState(false);
  const [selectedExchange, setSelectedExchange] = useState({});

  const topExchangesId = topExchanges?.map((ex) => ex?.id);

  const exchanges = [
    { name: "Demo Exchange", id: "cryptocrispy" },
    ...confirmedExchanges,
  ];

  const otherIntegratedExchange = integratedData?.filter(
    (item) => !topExchangesId?.includes(item?.id),
  );

  const location = useLocation();
  const dispatch = useDispatch();

  const navigateToConnectionPage = (name, id) => {
    dispatch(openExchangeConnectionSettings(id));
  };
  const clickHandler = (e, name, i) => {
    if (e.target.closest("li")) {
      const exchangeId = e.target.closest("li").id;
      setSelectedExchangeId(exchangeId);
      setSelectedExchangeName(name);

      const isInWizard = location.pathname.includes("wizard");

      const exchangeData = integratedData?.find(
        (item) => item?.id === exchangeId,
      );

      if (exchangeData) {
        if (
          exchangeData?.status !== "Active" &&
          exchangeData?.ip_status !== "OK"
        ) {
          setSelectedExchange(exchangeData);
          setShowIpSettingsModal(true);
          return;
        }
      }

      if (exchangeId === "cryptocrispy") {
        return Modal.info({
          content: (
            <h3>
              This is a virtual exchange with no integration required. It comes
              loaded with $1,000 in virtual funds, allowing you to test our bots
              and trade with our AI assistant for free.
            </h3>
          ),
          centered: true,
        });
      }

      if (!isInWizard) {
        if (exchangeData?.status === "Active") {
          setShowRecommendationModal(true);
        } else {
          navigateToConnectionPage(name, exchangeId);
        }
      } else {
        navigateToConnectionPage(name, exchangeId);
      }
    }
  };

  useEffect(() => {
    if (
      userData?.["cognito:username"] &&
      !Object.keys(exchangesInfo).length &&
      !exchangesLoading &&
      !exchangesError
    ) {
      dispatch(getExchangesInfo());
    }
  }, [
    dispatch,
    exchangesInfo,
    exchangesLoading,
    integratedData,
    integratedDataLoading,
    userData,
    exchangesError,
  ]);

  useEffect(() => {
    if (
      userData?.["cognito:username"] &&
      !integratedDataLoading &&
      !getIntegratedList &&
      !integratedDataError
    ) {
      dispatch(
        getIntegratedExchanges(
          userData?.["custom:custom_username"],
          userData?.["cognito:username"],
        ),
      );
    }
  }, [
    dispatch,
    integratedDataLoading,
    userData,
    getIntegratedList,
    integratedDataError,
  ]);

  // <LiaCertificateSolid />

  useEffect(() => {
    // console.log(location);
    localStorage.setItem("location", location.pathname);
  }, [location]);

  return (
    <div className={styles.container}>
      {exchangesLoading && (
        <div className={styles.loader}>
          <Spin tip="Loading exchanges list..." />
        </div>
      )}

      {!exchangesLoading && Object.keys(exchangesInfo).length && (
        <ul className={styles.exchangesList}>
          {exchanges.map((ex, i) => (
            <li
              onClick={(e) => clickHandler(e, ex?.name, i)}
              className={`${styles.exchangeItem} ${ex?.id === "cryptocrispy" ? styles.virtualExchange : ""} ${!!integratedData?.find((item) => item?.name === ex?.name && item?.status === "Active") ? styles.connected : ""}`}
              // className={`${styles.exchangeItem} ${
              //   i === 0
              //     ? styles.virtualExchange
              //     : ex?.name === "Swyftx"
              //       ? styles.auExchange
              //       : ex?.name === "Binance"
              //         ? styles.firstExchange
              //         : i === 2
              //           ? styles.secondExchange
              //           : i === 3
              //             ? styles.thirdExchange
              //             : ""
              // } ${
              //   !!integratedData.find(
              //     (item) => item.name === ex?.name && item.status === "Active",
              //   )
              //     ? styles.connected
              //     : ""
              // } ${
              //   !!integratedData.find(
              //     (item) => item.name === ex?.name && item.status !== "Active",
              //   )
              //     ? styles.expired
              //     : ""
              // }
              // ${
              //   !!integratedData.find(
              //     (item) =>
              //       item.name === ex?.name &&
              //       item.ip_status !== "OK" &&
              //       item.status !== "Active",
              //   )
              //     ? styles.ipRequired
              //     : ""
              // }`}
              key={ex?.name}
              id={ex?.id}
            >
              <LazyLoadImage
                src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${ex?.id}.svg`}
                alt={ex?.name}
                width="25px"
                height="25px"
                effect="blur"
              />
              <span className={styles.exchangeName}>{ex?.name}</span>
              {!certificatedExchange.includes(ex?.id) && (
                <span className={styles.previewBadge}>Preview</span>
              )}
              {/*{certificatedExchange.includes(ex?.id) ? (*/}
              {/*  <LiaCertificateSolid*/}
              {/*    title={"Certificated"}*/}
              {/*    className={styles.certificatedBadge}*/}
              {/*  />*/}
              {/*) : (*/}
              {/*  <span className={styles.previewBadge}>Preview</span>*/}
              {/*)}*/}
            </li>
          ))}

          {/*{otherIntegratedExchange.length > 0 &&*/}
          {/*  otherIntegratedExchange.map((item, i) => (*/}
          {/*    <li*/}
          {/*      onClick={(e) => clickHandler(e, item.name, i)}*/}
          {/*      className={`${styles.exchangeItem} ${*/}
          {/*        item.status === "Active" ? styles.connected : ""*/}
          {/*      } ${item.status !== "Active" ? styles.expired : ""} ${*/}
          {/*        !!integratedData.find(*/}
          {/*          (i) =>*/}
          {/*            i.name === item.name &&*/}
          {/*            i.ip_status !== "OK" &&*/}
          {/*            item.status !== "Active",*/}
          {/*        )*/}
          {/*          ? styles.ipRequired*/}
          {/*          : ""*/}
          {/*      }`}*/}
          {/*      key={item.name}*/}
          {/*      id={item.id}*/}
          {/*    >*/}
          {/*      <img*/}
          {/*        className={styles.exchangeImg}*/}
          {/*        src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${item.id}.svg`}*/}
          {/*        alt={item.name}*/}
          {/*      />*/}
          {/*      <span className={styles.exchangeName}>{item.name}</span>*/}
          {/*      {!certificatedExchange.includes(item?.id) && (*/}
          {/*        <span className={styles.previewBadge}>Preview</span>*/}
          {/*      )}*/}
          {/*      /!*{certificatedExchange.includes(item?.id) ? (*!/*/}
          {/*      /!*  <LiaCertificateSolid*!/*/}
          {/*      /!*    title={"Certificated"}*!/*/}
          {/*      /!*    className={styles.certificatedBadge}*!/*/}
          {/*      /!*  />*!/*/}
          {/*      /!*) : (*!/*/}
          {/*      /!*  <span className={styles.previewBadge}>Preview</span>*!/*/}
          {/*      /!*)}*!/*/}
          {/*    </li>*/}
          {/*  ))}*/}
          {/*<li*/}
          {/*  className={styles.exchangeItem}*/}
          {/*  onClick={() => setShowExchanges(true)}*/}
          {/*>*/}
          {/*  <TfiMoreAlt />*/}
          {/*  <span>More</span>*/}
          {/*</li>*/}
          {integratedDataLoading && (
            <li className={styles.loadingOverlay}>
              <div className={styles.loaderBox}>
                <Spin />
                <p>
                  Our platform is currently assessing the expiration status for
                  the exchanges integrated within our system.
                </p>
              </div>
            </li>
          )}
        </ul>
      )}

      <ExchangeRecommendationModal
        show={showRecommendationModal}
        setShow={setShowRecommendationModal}
        exchange={{ name: selectedExchangeName, id: selectedExchangeId }}
      />

      <ExchangesModal show={showExchanges} setShow={setShowExchanges} />
      <UpdateExchangeIpModal
        show={showIpSettingsModal}
        setShow={setShowIpSettingsModal}
        exchangeData={selectedExchange}
      />
    </div>
  );
}

export default TopExchanges;
